import { render } from "./Detail.vue?vue&type=template&id=c04a9762&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=c04a9762&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c04a9762"

export default script